var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z",
    fill: "#191A23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 23.6933C10.033 24.1133 9.78703 25.0234 10.201 25.7434C10.615 26.4634 11.533 26.7034 12.25 26.2934L10.75 23.6933ZM30.269 15.3834C30.484 14.5834 30.009 13.7634 29.209 13.5434L16.169 10.0534C15.369 9.83344 14.546 10.3134 14.332 11.1134C14.117 11.9134 14.5921 12.7333 15.3921 12.9433L26.983 16.0534L23.878 27.6434C23.663 28.4434 24.138 29.2634 24.938 29.4834C25.738 29.6934 26.5611 29.2234 26.7751 28.4234L30.269 15.3834ZM12.25 26.2934L29.571 16.2934L28.071 13.6933L10.75 23.6933L12.25 26.2934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowl);
export default __webpack_public_path__ + "static/media/arrowl.eef3ebc471c4d673ccb2decaa81b7f13.svg";
export { ForwardRef as ReactComponent };